import styled from '@emotion/styled'
import { Z_INDEX } from '@liveHelper/constants'
import { CHAT_HEADER_HEIGHT } from '@oneToOne/shared/components/chat/constants'
import { FlexCenter } from '@oneToOne/shared/styles'

export const ChatHeaderDialingWrapper = styled.div`
  position: relative;
  ${FlexCenter};
  flex-direction: column;
  width: 100%;
  height: ${CHAT_HEADER_HEIGHT.videoContainer}px;
`

export const ActionContainer = styled.div`
  ${FlexCenter}
  position: absolute;
  top: var(--spacing-16);
  right: var(--spacing-16);
  z-index: ${Z_INDEX.FLOATING_ACTION};
`
